export const DATA_SOURCES_COUNT = '20,000';
